import './Highlight.light.css'

const operatorStyles = {
    '=': 'highlight-token-equal',
    '+': 'highlight-token-plus',
    '-': 'highlight-token-minus',
    '*': 'highlight-token-multiply',
    '/': 'highlight-token-divide',
}

const tokenRegex = /([a-zA-Z][a-zA-Z0-9]*(?::[a-zA-Z0-9]+)*|\d+(?:[,.]\d+)?|[=+\-*/()]|\s+|.)/g

function HighlightFormulaToken({ token, index }) {

    if (/^\s+$/.test(token)) {
        return <span key={index}>{token}</span>
    }

    if (operatorStyles[token]) {
        return <span key={index} className={`highlight-token-operator ${operatorStyles[token]}`}>{token}</span>
    }

    if (token === '(' || token === ')') {
        return <span key={index} className="highlight-token-muted">{token}</span>
    }

    if (/^\d/.test(token)) {
        return <span key={index} className="highlight-token-number">{token}</span>
    }

    if (token.includes(':')) {
        const parts = token.split(':')
        return (
            <span key={index}>
                {parts.map((part, partIndex) => (
                    <span key={`${index}-${partIndex}`}>
                        {partIndex > 0 && <span className="highlight-token-muted">:</span>}
                        <span className={partIndex === 0 ? 'highlight-token-primary' : partIndex === parts.length - 1 ? 'highlight-token-value' : 'highlight-token-secondary'}>{part}</span>
                    </span>
                ))}
            </span>
        )
    }

    if (/^[a-zA-Z][a-zA-Z0-9]*$/.test(token)) {
        return <span key={index} className="highlight-token-primary">{token}</span>
    }

    return <span key={index}>{token}</span>

}

function HighlightFormulaLine({ line, lineIndex }) {

    if (!line) {
        return '\u00A0'
    }

    const commentIndex = line.indexOf('//')
    const formula = commentIndex >= 0 ? line.substring(0, commentIndex) : line
    const comment = commentIndex >= 0 ? line.substring(commentIndex) : ''

    return (
        <>
            {(formula.match(tokenRegex) || ['']).map((token, tokenIndex) => <HighlightFormulaToken key={`${lineIndex}-${tokenIndex}`} token={token} index={`${lineIndex}-${tokenIndex}`} />)}
            {comment && <span className="highlight-token-comment">{comment}</span>}
        </>
    )

}

export default function Highlight({ value = '', className = '' }) {

    const lines = String(value || '').split('\n')

    return (
        <div className={`highlight surface-ground border-200 border-round text-sm line-height-3 overflow-auto ${className}`}>
            {lines.map((line, lineIndex) => (
                <div key={lineIndex}>
                    <HighlightFormulaLine line={line} lineIndex={lineIndex} />
                </div>
            ))}
        </div>
    )

}
